/**
 * DataRow — 라벨/값 데이터 행 (목업 `.row` + `.k` / `.v`).
 *
 * 순수 프레젠테이션. 라벨은 좌측(회색), 값은 우측(볼드·tabular-nums).
 * 상단 하이라인으로 행을 구분하며, 형제 중 첫 행은 하이라인을 생략한다.
 */

import React from 'react';

export interface DataRowProps {
  label: string;
  value: React.ReactNode;
  className?: string;
}

export function DataRow({ label, value, className = '' }: DataRowProps) {
  return (
    <div
      className={`flex items-baseline justify-between gap-3 border-t border-ca-line-soft py-[9px] first:border-t-0 ${className}`}
    >
      <span className="flex-shrink-0 text-[12.5px] text-muted">{label}</span>
      <span className="min-w-0 break-words text-right text-[13px] font-bold tabular-nums text-ink">
        {value}
      </span>
    </div>
  );
}

export default DataRow;
